import { ToastRegion } from '@lego/connect-components-react';
import { KlikProvider } from '@lego/klik-ui';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import type { ReactElement } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { RouteComponents } from './RouteComponents';
import { AuthProvider } from './context/auth-context';
import { theme } from './theme/theme';
import './temporary-klik-provider-overrides.css';
import { ErrorPage } from '@pages/error-page';
import { ErrorBoundary } from 'react-error-boundary';

const queryClient = new QueryClient();

export const App = (): ReactElement => {
  return (
    <>
      <ToastRegion />
      <ErrorBoundary
        fallback={<div>A critical error occurred. Please reload.</div>}
      >
        <KlikProvider theme={theme} legacyFont={false}>
          <QueryClientProvider client={queryClient}>
            <AuthProvider>
              <Router />
            </AuthProvider>
            <ReactQueryDevtools initialIsOpen={false} />
          </QueryClientProvider>
        </KlikProvider>
      </ErrorBoundary>
    </>
  );
};

const Router = (): ReactElement => {
  return (
    <BrowserRouter basename={import.meta.env.BASE_URL}>
      <RouteErrorBoundary />
    </BrowserRouter>
  );
};
const RouteErrorBoundary = (): ReactElement => {
  const location = useLocation();
  return (
    <ErrorBoundary
      FallbackComponent={ErrorPage}
      resetKeys={[location.pathname]}
    >
      <RouteComponents />
    </ErrorBoundary>
  );
};
